// NapTap - Variant Image Fix
// Fixes dynamic image switching for DreamBud product (and all products)
// when variant images are not pre-rendered in the Horizon gallery carousel.

(function () {
  // Only run on product pages
  if (!window.location.pathname.includes('/products/')) return;

  var productMediaByPosition = {};
  var galleryMediaIds = new Set();

  function init() {
    var handle = window.location.pathname.replace('/products/', '').split('?')[0].split('/')[0];
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        // Map position → media item
        product.media.forEach(function (m) {
          productMediaByPosition[m.position] = m;
        });
        // Map variant id → featured_image
        window._variantFI = {};
        product.variants.forEach(function (v) {
          if (v.featured_image) window._variantFI[v.id] = v.featured_image;
        });
        // Record which media IDs are already rendered in the gallery DOM
        var gallery = document.querySelector('media-gallery');
        if (gallery) {
          gallery.querySelectorAll('[data-media-id]').forEach(function (el) {
            galleryMediaIds.add(Number(el.getAttribute('data-media-id')));
          });
        }
      });
  }

  function handleVariantChange(variantId) {
    var fi = window._variantFI ? window._variantFI[variantId] : null;
    if (!fi) return;

    var media = productMediaByPosition[fi.position];
    if (!media) return;

    // If this media IS in the gallery, Horizon handles navigation natively
    if (galleryMediaIds.has(media.id)) return;

    // Media is NOT in the gallery — force the visible slide to show the variant image
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    var baseUrl = fi.src.split('?')[0];

    // Update all slides that share the first media ID (carousel clones the first slide)
    var allSlides = Array.from(gallery.querySelectorAll('[data-media-id]'));
    if (!allSlides.length) return;

    var firstMediaId = allSlides[0].getAttribute('data-media-id');
    gallery.querySelectorAll('[data-media-id="' + firstMediaId + '"]').forEach(function (slide) {
      var img = slide.querySelector('img');
      if (!img) return;
      img.src = baseUrl + '?width=800';
      img.srcset =
        baseUrl + '?width=400 400w,' +
        baseUrl + '?width=800 800w,' +
        baseUrl + '?width=1200 1200w';
      var picture = img.closest('picture');
      if (picture) {
        picture.querySelectorAll('source').forEach(function (s) {
          s.srcset = baseUrl + '?width=800 800w';
        });
      }
    });

    // Scroll carousel back to first slide so the updated image is visible
    var scroller = allSlides[0].parentElement;
    if (scroller) scroller.scrollLeft = 0;
  }

  // Listen for variant radio button changes (data-variant-id attribute)
  document.addEventListener('change', function (e) {
    if (!e.target.hasAttribute('data-variant-id')) return;
    if (!e.target.checked) return;
    handleVariantChange(parseInt(e.target.getAttribute('data-variant-id'), 10));
  });

  // Initialize after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
